<template>
  <div ref="box">
    <div v-show="visibleRect" class="position-absolute frame-time__rect" :style="{left: rectLeft + 'px', width: rectWidth + 'px'}" @click="visibleMenu = false" @contextmenu.prevent="onRectContext">
      <div class="position-absolute start-100 ps-1 text-nowrap" style="transform: translateX(0) translateY(0);color: #8943d1;">
        <div><span class="frame-time__label">帧序号:</span> {{ startXValue + 1 }}-{{ endXValue + 1 }}</div>
        <!-- <div><span class="frame-time__label">Avg(FPS):</span> {{ rectInfo.avgFps }}</div>
        <div><span class="frame-time__label">Min(FPS):</span> {{ rectInfo.minFps }}</div>
        <div><span class="frame-time__label">FPS>=18 [%]:</span> {{ rectInfo.fps18 }}</div>
        <div><span class="frame-time__label">FPS>=25 [%]:</span> {{ rectInfo.fps25 }}</div> -->
      </div>
    </div>

    <div v-show="visibleMenu" class="position-absolute shadow bg-white" :style="{left: menuLeft + 'px', top: menuTop + 'px'}" @click.prevent>
      <button type="button" class="btn-operate d-block py-2 px-3 border-0 w-100" @click="onEditLabel">
        <i class="el-icon-edit-outline me-2" style="font-size: 16px;"></i>标签
      </button>
      <button type="button" class="btn-operate d-block py-2 px-3 border-0 w-100">
        <i class="el-icon-delete me-2" style="font-size: 16px;"></i>删除
      </button>
    </div>

    <dialog-label ref="dialogLabel" />
  </div>
</template>

<script>
import DialogLabel from './dialog-label.vue'

export default {
  data() {
    return {
      visibleMenu: false,
      menuLeft: 0,
      menuTop: 0,
    }
  },

  components: {DialogLabel},

  props: {
    visibleRect: Boolean,
    rectLeft: Number,
    rectWidth: Number,
    startXValue: Number,
    endXValue: Number,
  },

  methods: {
    onRectContext(e) {
      const container = this.$refs.box.parentNode
      const rect = container.getBoundingClientRect()

      this.menuLeft = e.clientX - rect.left + 4
      this.menuTop = e.clientY - rect.top + 4
      this.visibleMenu = true
    },

    onEditLabel() {
      this.$refs.dialogLabel.show()
    }
  }
}
</script>

<style scoped>
.frame-time__point {
  top: 61px;
}

.frame-time__line {
  position: relative;
  left: -1.5px;
  width: 3px;
  height: 170px;
  background: #8943d1;
}

.frame-time__text {
  top: 7px;
  left: 5px;
  color: #8943d1;
  font-size: 15px;
}

.frame-time__rect {
  top: 100px;
  bottom: 100px;
  border: 2px solid #1364e9;
  background: rgba(19, 100, 233, .2);
}

.frame-time__label {
  display: inline-block;
  width: 100px;
}

.frame-time__label2 {
  display: inline-block;
  width: 140px;
}

.btn-operate {
  background: none;
}

.btn-operate:hover {
  color: blue;
  background: rgb(248,249,250);
}
</style>